import React from "react";
import { Col, Modal, Row, Space, Typography } from "antd";

interface ApiPartnerKeysProps {
  visible: boolean;
  clientId: string;
  clientSecret: string;
  updateModalState: () => void;
}

const { Title } = Typography;

const ApiPartnerKeys = ({ visible, clientId, clientSecret, updateModalState }: ApiPartnerKeysProps) => {
  return (
    <Modal
      title="API Partner Keys"
      visible={visible}
      okText="Ok"
      style={{ minWidth: 740 }}
      onCancel={updateModalState}
      onOk={updateModalState}
    >
      <Space direction="vertical" size="middle">
        <Row>
          <Col>
            <Row>
              <Col>
                <Title level={5}>Client Id</Title>
              </Col>
            </Row>
            <Row>
              <Col>{clientId}</Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col>
            <Row>
              <Col>
                <Title level={5}>Client Secret</Title>
              </Col>
            </Row>
            <Row>
              <Col>{clientSecret}</Col>
            </Row>
          </Col>
        </Row>
      </Space>
    </Modal>
  );
};

export default ApiPartnerKeys;
